<template>
  <form-group>
    <v-row>
      <v-col cols="12">
        <v-card flat>
          <v-card-text>
            <form-group class="pt-0">
              <v-row
                class="pb-3"
                justify="start"
              >
                <v-col cols="6">
                  <chip
                    :payload="storeNameChip"
                    :loading="loading"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-tabs
                    v-model="tabs"
                    vertical
                  >
                    <v-tab>
                      Dados gerais
                    </v-tab>

                    <v-tab>
                      Endereço
                    </v-tab>

                    <v-tab>
                      Produtos e serviços
                    </v-tab>

                    <v-tabs-items
                      v-model="tabs"
                      vertical
                      class="border-left"
                    >
                      <v-tab-item>
                        <form-group class="pb-6">
                          <v-row>
                            <v-col cols="6">
                              <input-text
                                v-model="payload.nomLoja"
                                label="Nome Fantasia"
                                :loading="loading"
                              />
                            </v-col>
                            <v-col cols="6">
                              <input-mask
                                v-model="payload.numCnpj"
                                label="CNPJ"
                                :loading="loading"
                                disabled
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="6">
                              <input-phone
                                :value="TelefoneFilter(payload.numTelefone)"
                                label="Telefone"
                                :loading="loading"
                              />
                            </v-col>
                            <v-col cols="6">
                              <input-select-request
                                v-model="payload.idSegmento"
                                :request-class="proxySegmentRequest"
                                prop-text="nomSegmento"
                                fault-message="Falha ao buscar listagem de segmentos!"
                                label="Segmento"
                                :loading="loading"
                                disabled
                              />
                            </v-col>
                          </v-row>
                        </form-group>
                      </v-tab-item>
                      <v-tab-item>
                        <address-inputs-scope
                          ref="address"
                          v-model="payload.enderecoOutputJO"
                          :reference-value="referenceAddress"
                          :loading="loading"
                          @address-loading="handleAddressLoading($event)"
                        />
                      </v-tab-item>

                      <v-tab-item>
                        <user-product-store-content
                          v-model="payload.id"
                          :loading="loading"
                        />
                      </v-tab-item>
                    </v-tabs-items>
                  </v-tabs>
                </v-col>
              </v-row>
              <v-row>
                <v-spacer />
                <v-btn
                  v-if="tabs === 0"
                  color="success"
                  :loading="isLoading"
                  @click="makeSave()"
                >
                  Salvar
                </v-btn>
                <!-- <v-btn
                  v-else
                  color="primary"
                  outlined
                  :loading="isLoading"
                  @click="tabs = 1"
                >
                  continuar
                </v-btn> -->
              </v-row>
            </form-group>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </form-group>
</template>

<script>
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import StoreRequest from 'App/users/services/StoreRequest';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import AddressInputsScope from '@/app/arch/components/scopes/AddressInputsScope.vue';
import SegmentoRequest from '@/app/modules/contacard/segmento/SegmentoRequest';
import UserProductStoreContent from 'App/users/components/contents/UserProductStoreContent.vue';
import Chip from '@/app/arch/components/global-components/Chip.vue';
import TelefoneFilter from '@/app/arch/filters/TelefoneFilter';

export default {
  name: 'UserStoreForm',
  components: {
    FormGroup, AddressInputsScope, UserProductStoreContent, Chip,
  },
  mixins: [ServiceMixin],
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
  },
  data: () => ({
    requestClass: StoreRequest,
    requestSegment: SegmentoRequest,
    tabs: null,
    TelefoneFilter,
    payload: {
      id: '',
      createdDate: '',
      updatedDate: '',
      deletedDate: '',
      idCliente: '',
      nomLoja: '',
      numTelefone: '',
      idEndereco: '',
      txtComplementoEndereco: '',
      numEndereco: '',
      indStatus: 'A',
      idTemplate: '',
      numCnpj: '',
      idSegmento: '',
      enderecoOutputJO: {
        idEndereco: '',
        logradEnd: '',
        bairroEnd: '',
        cidadeEnd: '',
        estadoEnd: '',
        numCep: '',
        tipoLogradouro: '',
      },
    },
    loading: false,
    storeConfig: {
      errorMessage: 'Falha ao buscar dados da loja!',
      successMessage: 'Sucesso Ao atualizar loja!',
      showSuccessSwal: false,
    },
    addressLoading: false,
  }),
  computed: {
    refAddress() {
      return this.$refs.address || {
        saveAddress: (v) => v,
      };
    },
    proxySegmentRequest() {
      return (params) => this.requestSegment.list(params);
    },
    storeId() {
      return this.value;
    },
    referenceAddress() {
      return {
        logradouro: 'logradEnd',
        bairro: 'bairroEnd',
        localidade: 'cidadeEnd',
        uf: 'estadoEnd',
        cep: 'numCep',
        id: 'idEndereco',
        tipoLogradouro: 'tipoLogradouro',
      };
    },
    isLoading() {
      return this.loading || this.addressLoading;
    },
    handleAddressLoading() {
      return (val) => {
        this.addressLoading = val;
      };
    },
    getEditStore() {
      return (id) => this.requestClass.edit(
        this.storeId,
        {
          ...this.payload,
          idEndereco: id,
        },
      );
    },
    addressPayload() {
      const {
        numCep, bairroEnd, logradEnd,
        tipoLogradouro,
      } = this.payload.enderecoOutputJO;
      return {
        cep: String(numCep).replace(
          /[^0-9]/g,
          '',
        ),
        bairro: bairroEnd,
        logradouro: logradEnd,
        tipoLogradouro,
      };
    },
    storeNameChip() {
      return {
        color: '#F9FAFB',
        textColor: '#69737D',
        label: this.payload.nomLoja,
      };
    },
  },
  watch: {
    storeId: {
      immediate: true,
      handler(id) {
        if (Number(id) >= 1) {
          this.getStoreData();
        }
      },
    },
  },
  created() {
    this.openProductTab();
  },
  methods: {
    makeSave() {
      this.makeSaveEditRequests();
    },
    makeSaveEditRequests() {
      this.handleAddressLoading(true);
      this.callService(
        this.getEditStore(
          this.payload.enderecoOutputJO.idEndereco,
        ),
        () => {
          this.handleAddressLoading(false);
        },
        {
          ...this.storeConfig,
          showSuccessSwal: true,
        },
      );
    },
    getStoreData() {
      this.handleLoading();
      this.makeStoreRequest();
    },
    handleLoading() {
      this.loading = !this.loading;
    },
    makeStoreRequest() {
      this.callService(
        this.requestClass.get(
          this.storeId,
        ),
        this.setPayload,
        this.storeConfig,
      );
    },
    setPayload(response) {
      this.handleLoading();
      if (this.hasData(response)) {
        this.payload = this.overrideNullProperties(
          response.data,
          this.payload,
        );
      }
    },
    openProductTab() {
      this.$root.$on('open-user-store-product', (id) => {
        if (Number(id) >= 1) {
          this.tabs = 2;
        }
      });
    },
  },
  reactiveProvide: {
    name: 'userStoreForm',
    include: ['payload', 'loading'],
  },
};
</script>

<style scoped>
.border-left {
  border-left: 1px solid #F1F3F5;
}
</style>
